import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cart.svg';
export default {
  name: 'PlusDisplayLayer',
  props: {
    context: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      required: true
    },
    reference: {
      type: String,
      required: true
    },
    layer: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread({}, mapGetters({
    items: 'layer/items'
  })),

  mounted() {
    var payload = {
      reference: this.reference,
      src: this.src
    };
    this.appendItems(payload);
  },

  methods: _objectSpread(_objectSpread({}, mapActions({
    setCurrentLayer: 'layer/setCurrentLayer',
    appendItems: 'layer/appendItems'
  })), {}, {
    openLayer() {
      if (!this.layer) {
        this.$root.$emit('open-layer', {
          state: true,
          name: 'LayerProduct',
          context: this.context,
          items: this.items
        });
        this.setCurrentLayer({
          item: {
            reference: this.reference,
            src: this.src
          },
          index: this.reference
        });
      }
    }

  })
};